// @flow
import type { Action, VmEvent } from './types';

export const logVmPlayerEvent = (event: VmEvent, menu: string = ''): Action => ({
  type: 'VM_ANALYTICS_PLAYER_EVENT',
  isVmSpecific: true,
  event,
  menu,
});

export const logVmFranchiseEvent = (event: VmEvent, menu: string): Action => ({
  type: 'VM_FRANCHISE_OPEN_EVENT',
  isVmSpecific: true,
  event,
  menu,
});

export const logVmPreviewOpenEvent = (event: VmEvent): Action => ({
  type: 'VM_PREVIEW_OPEN_EVENT',
  isVmSpecific: true,
  event,
});

export const logBillingFirstFrameRenderedEvent = (): Action => ({
  type: 'BILLING_FIRST_FRAME_RENDERED',
  isVmSpecific: true,
});

export const logBillingActiveUserEvent = (): Action => ({
  type: 'BILLING_ACTIVE_USER_SIGN_IN',
  isVmSpecific: true,
});
